import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

export interface MenuItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  hoverIcon?: React.ReactNode;
  count?: number | string;
}

interface Props {
  menus: MenuItem[];
  value: string;
  onChange: (value: string) => void;
}

export default function ScrollableBottomMenu({
  menus,
  value,
  onChange,
}: Props) {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 15,
        left: 15,
        right: 15,
        bgcolor: "#fff",
        borderRadius: "26px",
        boxShadow: "0 10px 35px rgba(0,0,0,.11)",
        overflow: "hidden",
        zIndex: 1200,
      }}
    >
      <Box
        sx={{
          display: "flex",
          overflowX: "auto",
          justifyContent:'center',
          px: 1,
          pt: '10px',
          pb:'10px',
          "&::-webkit-scrollbar": {
            display: "none",
          },

          scrollbarWidth: "none",
        }}
      >
        {menus.map((item) => {
          const active = value === item.id;
          const isHovered = hoveredId === item.id;
          const iconToRender = active
            ? item.activeIcon ?? item.icon
            : isHovered && item.hoverIcon
              ? item.hoverIcon
              : item.icon;

          return (
            <Box
              key={item.id}
              onClick={() => onChange(item.id)}
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
              sx={{
                minWidth: 70,
                flexShrink: 0,
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                {/* Active Half Circle */}
                {active && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -28,
                      width: 28,
                      height: 28,
                      bgcolor: "#6A0DAD",
                      borderBottomLeftRadius: 100,
                      borderBottomRightRadius: 100,
                    }}
                  />
                )}

                {/* Icon */}
                <Box
                  sx={{
                    mt: active ? 0.5 : 2,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: ".3s",
                    color: active || isHovered ? "#6A0DAD" : "#8d8d8d",

                    "& svg, & img": {
                      width: 20,
                      height: 20,
                      objectFit: "contain",
                    },
                  }}
                >
                  {iconToRender}
                  {item.count !== undefined && item.count !== null ? (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 2,
                        right: 8,
                        minWidth: 18,
                        height: 18,
                        bgcolor: "#6A0DAD",
                        color: "#fff",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 10,
                        fontWeight: 400,
                        px: 0.5,
                      }}
                    >
                      {item.count}
                    </Box>
                  ) : null}
                </Box>

                <Typography
                  sx={{
                    mt: 0.5,
                    fontSize: 13,
                    fontWeight: active ? 500 : 300,
                    //color: active ? "#00B96B" : "#808080",
                    color: active ? "#6A0DAD" : "#808080",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}